import { LandingLayout } from 'layouts';
import { ContentLeft, Footer, Header, type HeaderItem, LoginSignpost } from 'features/onboarding';
import { useOnSuccessLogin, useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type LoginSignpostLocationState = OnboardingLocationState;

const PageLoginSignpost = () => {
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToCheckCode, onNavigateToPasswordlessLogin, onNavigateToPasswordLogin, onNavigateToSignUp } =
    useOnboardingNavigation<LoginSignpostLocationState>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onSuccessLogin } = useOnSuccessLogin<LoginSignpostLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Sign up',
      async onClick() {
        await onNavigateToSignUp();
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <LoginSignpost
          onNavigateToCheckCode={onNavigateToCheckCode}
          onNavigateToPasswordlessLogin={onNavigateToPasswordlessLogin}
          onNavigateToPasswordLogin={onNavigateToPasswordLogin}
          onNavigateToSignUp={onNavigateToSignUp}
          onSuccessLogin={onSuccessLogin}
        />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PageLoginSignpost;
